// apis
import { NationAPI } from '../apis/nation.api';

// libraries
import { selector } from 'recoil';

export const NationAtom = selector({
  key: 'NationAtom',
  get: async () => {
    try {
      const res = await new NationAPI().getNationList({
        page: 0,
        size: 999
      });

      const options = res.resultList.map((item) => ({
        value: String(item.nationId),
        label: item.countryName
      }));

      return {
        list: res.resultList || [],
        options
      };
    } catch (error) {
      throw error;
    }
  }
});
